import { useCallback, useState, useRef } from 'react';

import { API_URLS } from '../../../components/common/headers';
import { protectApiViaOkta } from '../../../utils/protectApiViaOkta';
import { saveExcel } from '../helpers/saveExcel';

export const useLocationsExcelDownload = ({
  responseData,
  totalCount,
  searchRequestObject,
  providerName,
}) => {
  const [downloading, setDownloading] = useState(false);

  const returnArrayRef = useRef([]);

  const getDownloadData = useCallback(
    async (pageno, totalCount, reqObject) => {
      if (pageno > Math.ceil(totalCount / 1000)) {
        saveExcel(returnArrayRef.current, providerName);
        returnArrayRef.current = [];

        // All data has been fetched
        return;
      }

      const URL = `${API_URLS.searchProviderLocationsURL}`;
      const headers = { 'Content-Type': 'application/json' };

      const updatedPage = { cPage: pageno };

      reqObject.callNumber = updatedPage.cPage;

      try {
        setDownloading(true);

        await protectApiViaOkta('post', URL, reqObject, headers).then(function (response) {
          if (response?.status === 200 && response?.data && response?.data?.length > 0) {
            const obj_arr_appended = response.data.map(function (currentValue, Index) {
              let preResponseLength = 0;

              if (!!responseData && responseData?.length > 0) {
                preResponseLength = responseData?.length;
              }

              currentValue.SERIAL_NO = preResponseLength + Index + 1;

              const emailContatcs =
                currentValue && currentValue?.provider_contact_info
                  ? currentValue.provider_contact_info.map((s) => s?.email)
                  : [];

              currentValue.emailContacts = emailContatcs;

              if (!currentValue.provider_updated_date) {
                currentValue.provider_updated_date = currentValue.provider_created_date;
              }

              return currentValue;
            });

            returnArrayRef.current = returnArrayRef.current.concat(obj_arr_appended);

            getDownloadData(pageno + 1, totalCount, searchRequestObject);
          } else {
            console.error('Error: Data is not found in the response');
          }
        });
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setDownloading(false);
      }
    },
    [responseData, searchRequestObject, providerName],
  );

  const downloadLocationsData = useCallback(
    () => getDownloadData(1, totalCount, searchRequestObject),
    [getDownloadData, searchRequestObject, totalCount],
  );

  return { downloading, downloadLocationsData };
};
